/**
 * Возвращает true, если приложение запущено внутри Telegram WebApp
 * на мобильной платформе (Android или iOS).
 *
 * На десктопе (браузер или Telegram Desktop / macOS клиент) и
 * в обычном браузере без Telegram возвращает false — там показывается
 * экран с QR-кодом для перехода в мобильный Telegram.
 */
export const isMobileTelegram = () => {
  if (typeof window === 'undefined') return false;

  const tg = window?.Telegram?.WebApp;
  if (!tg || !tg.initData) return false;

  // Платформы Telegram: android, android_x, ios, tdesktop, macos, weba, webk, unigram, unknown
  const platform = tg.platform;
  return platform === 'android' || platform === 'android_x' || platform === 'ios';
};

/**
 * Возвращает true, если приложение запущено внутри любого клиента Telegram
 * (мобильный, Telegram Desktop, macOS, Telegram Web) — есть initData.
 * В обычном браузере без Telegram возвращает false.
 */
export const isTelegramWebApp = () => {
  if (typeof window === 'undefined') return false;
  return Boolean(window?.Telegram?.WebApp?.initData);
};
